export const EMPLOYEE_COLORS = [
    "#4C6EF5", "#12B886", "#845EF7", "#F76707", "#E64980", "#15AABF", "#FAB005",
    "#7048E8", "#0CA678", "#E8590C", "#1C7ED6", "#D6336C",
];

export const STATUS_META = {
    scheduled: { color: "#64748b", bg: "#f1f5f9" },
    confirmed: { color: "#0ca678", bg: "#e6fcf5" },
    in_progress: { color: "#1c7ed6", bg: "#e7f5ff" },
    completed: { color: "#2f9e44", bg: "#ebfbee" },
    cancelled: { color: "#e03131", bg: "#fff5f5" },
    no_show: { color: "#f08c00", bg: "#fff9db" },
};

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function timeToMinutes(hhmm) {
    const [h, m] = hhmm.split(":").map(Number);
    return h * 60 + m;
}

export function minutesToTime(min) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function isoLocalDate(d) {
    const dt = new Date(d);
    return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
}
